// jshint esversion: 8

export default {
  getNotifications: state => state.notifications,
  getError: state => state.error,
  loading: state => state.loading,
  progress: state => state.progress,
  tokenExpiration: state => state.tokenExpire
};
